import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Layout from './Layout';

const PrivateRoute = ({ children, roles, perm }) => {
  const { isAuthenticated, loading, user, hasPermission } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Role-based guard
  if (roles && user?.role && !roles.includes(user.role)) {
    return <Navigate to={user.role === 'client' ? '/client-portal' : '/dashboard'} replace />;
  }

  // Permission-based guard (team/manager — admin always passes)
  if (perm && user?.role !== 'admin' && !hasPermission(perm)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Layout>{children}</Layout>;
};

export default PrivateRoute;
